module.exports = __webpack_public_path__ + "45bb986b87df2ff57b29beb34fe22ef7.pdf";